import type { Story } from '@/store/story-types'

export const CREATOR_BLOG_NEW3_STORY: Story = {
  id: 'creator-blog-new3',
  name: 'Inkwell — Creator Blog',
  narrative: 'A clean, typography-focused creator blog with featured post hero, article listing grid with category filters, article detail with rich content, newsletter signup, and reading time estimates.',
  goals: ['Browse articles with category filters', 'Read featured and recent posts', 'View article detail with reading time', 'Subscribe to newsletter'],
  lifecycle: 'ready',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'completed', elementCount: 7, linkedPageId: 'home', description: 'Blog home with featured post, article grid, categories, and newsletter' },
    { id: 'pg-article', title: 'Article', order: 1, status: 'completed', elementCount: 5, linkedPageId: 'article', description: 'Article detail with content, author info, and related posts' },
  ],
  bddScenarios: [
    {
      id: 'bdd-1', name: 'Browse Articles',
      description: 'Reader browses the blog home',
      steps: [
        { type: 'given', text: 'the reader opens the blog' },
        { type: 'when', text: 'the home page loads' },
        { type: 'then', text: 'featured post and article grid are displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2', name: 'Filter by Category',
      description: 'Reader filters articles by category',
      steps: [
        { type: 'given', text: 'the reader is on the blog home', linkedPageId: 'home' },
        { type: 'when', text: 'they select a category filter' },
        { type: 'then', text: 'only articles matching the selected category are shown' },
      ],
    },
    {
      id: 'bdd-3', name: 'Read Article',
      description: 'Reader opens and reads an article',
      steps: [
        { type: 'given', text: 'the reader sees an article card', linkedPageId: 'home' },
        { type: 'when', text: 'they tap the article card' },
        { type: 'then', text: 'the full article with content and reading time is displayed', linkedPageId: 'article' },
      ],
    },
    {
      id: 'bdd-4', name: 'Subscribe to Newsletter',
      description: 'Reader subscribes to the newsletter',
      steps: [
        { type: 'given', text: 'the reader scrolls to the newsletter section' },
        { type: 'when', text: 'they enter email and tap Subscribe' },
        { type: 'then', text: 'a success confirmation is shown', linkedFlowId: 'subscribe' },
      ],
    },
  ],
}
